import { createBaseThemeOptions, createUnifiedTheme, genPageTheme, palettes, shapes } from '@backstage/theme';
import PorscheNextRegular from '../assets/fonts/PorscheNextWLa-Regular.woff2';

const PorscheNextRegularFont = {
    fontFamily: 'PorscheNextRegularFont',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 300,
    src: `
        local('PorscheNextRegularFont'),
        url(${PorscheNextRegular}) format('woff2'),
        `,
};

/** Brand gradient applied to every page header */
const brandColors: [string, string] = ['#000000', '#D5001C'];

export const customTheme = createUnifiedTheme({
    ...createBaseThemeOptions({
        palette: {
            ...palettes.dark,
        },
    }),

    defaultPageTheme: 'home',
    fontFamily: PorscheNextRegularFont.fontFamily,
    /* below drives the header gradient colours for every standard Backstage themeId.
     * All entries use the brand gradient so that native plugin pages (API Docs, TechDocs,
     * Catalog, Scaffolder, etc.) get the same look as our custom pages. */
    pageTheme: {
        home:          genPageTheme({ colors: brandColors, shape: shapes.wave }),
        documentation: genPageTheme({ colors: brandColors, shape: shapes.wave2 }),
        tool:          genPageTheme({ colors: brandColors, shape: shapes.round }),
        service:       genPageTheme({ colors: brandColors, shape: shapes.wave }),
        website:       genPageTheme({ colors: brandColors, shape: shapes.wave }),
        library:       genPageTheme({ colors: brandColors, shape: shapes.wave }),
        other:         genPageTheme({ colors: brandColors, shape: shapes.wave }),
        app:           genPageTheme({ colors: brandColors, shape: shapes.wave }),
        apis:          genPageTheme({ colors: brandColors, shape: shapes.wave }),
    },
});
